import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { Observable } from 'rxjs';

interface DropboxProps {
  images: {
    [key: string]: string;
  };
}

const store = createStore(
  { name: 'dropbox' },
  withProps<DropboxProps>({
    images: {}
  })
);

@Injectable({
  providedIn: 'root'
})
export class DropboxRepository {
  public setImage(id: string, image: string): void {
    store.update((state) => ({
      ...state,
      images: {
        ...state.images,
        [id]: image
      }
    }));
  }

  public selectImage(id: string): Observable<string> {
    return store.pipe(select((state) => (id in state.images ? state.images[id] : null)));
  }

  public hasImage(id: string): boolean {
    return id in store.getValue().images && !!store.getValue().images[id];
  }

  public getImage(id: string): string {
    if (!this.hasImage(id)) return null;

    return store.getValue().images[id];
  }

  reset() {
    store.reset();
  }
}
